// Every cell tints under the pointer, as the dropdown and editor cells do.
export const CELL_CLASS =
  'flex h-9 w-full items-center px-2 text-[13px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring hover:bg-muted/60';
